module.exports = __webpack_public_path__ + "static/media/logo-name-white.3a8e023c.svg";